import { Pipe, PipeTransform } from '@angular/core';

import { RuntimeContainerActionModel } from '@blaze-runtime/engine-domain';
@Pipe({
  name: 'isActionDisabled',
})
export class IsActionDisabledPipe implements PipeTransform {
  transform(
    action: RuntimeContainerActionModel,
    pendingActions: { [key: string]: number },
    disableActionWhenPending: boolean,
  ): boolean {
    const result =
      !!action.isActionDisabledInAllRows ||
      (disableActionWhenPending && isActionPending(action.actionId, pendingActions));
    return result;
  }
}

@Pipe({
  name: 'isActionPending',
})
export class IsActionPendingPipe implements PipeTransform {
  transform(
    action: RuntimeContainerActionModel,
    pendingActions: { [key: string]: number },
  ): boolean {
    return isActionPending(action.actionId, pendingActions);
  }
}

export function isActionPending(
  actionId: string | undefined,
  pendingActions: { [key: string]: number },
): boolean {
  return actionId ? !!pendingActions[actionId] : false;
}
